module.exports = __webpack_public_path__ + "img/专项.78310e85.png";